import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DashboardRecruitmentSubsService {

    private textAction: Subject<string> = new Subject<string>();

    constructor() { }

    listenLoadTextAction(): Observable<string> {
        return this.textAction.asObservable();
    }

    fireLoadTextAction(text: string): void {
        this.textAction.next(text);
    }
}